import React from 'react';
import styles from './AgentStatus.module.scss';

/**
 * Three circles chasing around the corners of a square.
 *
 * Adapted from follow-square-circles.svg. The original drives itself with SMIL
 * <animateTransform>; this drives the same motion from CSS keyframes instead,
 * for two reasons SMIL cannot do:
 *   - prefers-reduced-motion can switch it off (CSS media queries do not reach
 *     inside SMIL)
 *   - the animation can be paused when the agent stops working, rather than
 *     looping forever behind a finished answer
 *
 * Colour is the brand orange and is deliberate, so it is set here rather than
 * inherited from currentColor.
 */

export const AGENT_MARK_COLOR = '#FF672A';

interface Props {
  /** Pixel size of the square. Defaults to sitting on the line of text. */
  size?: number;
  /** False parks the circles in their start positions. */
  animated?: boolean;
}

const AgentMark: React.FC<Props> = ({ size = 18, animated = true }) => (
  <svg
    className={styles.mark}
    width={size}
    height={size}
    viewBox="0 0 200 200"
    role="presentation"
    aria-hidden="true"
    focusable="false"
  >
    <g fill={AGENT_MARK_COLOR} stroke={AGENT_MARK_COLOR} strokeWidth="15">
      <circle
        className={animated ? styles.dotA : undefined}
        r="20"
        cx="140"
        cy="60"
      />
      <circle
        className={animated ? styles.dotB : undefined}
        r="20"
        cx="60"
        cy="60"
      />
      <circle
        className={animated ? styles.dotC : undefined}
        r="20"
        cx="60"
        cy="140"
      />
    </g>
  </svg>
);

export default AgentMark;
